import { router } from "@inertiajs/react";
import { EEligibilityStep } from "app/frontend/components/eligibility/constants";
import { useEdit } from "app/frontend/components/eligibility/hooks/useEdit";
import { useHead } from "app/frontend/components/eligibility/hooks/useHead";
import { EProjectTypes } from "app/frontend/constants/enums";
import { ROUTES } from "app/frontend/constants/routes";
import { useCurrentProjectType } from "app/frontend/hooks/project/useCurrentProjectType";
import { useParams } from "app/frontend/hooks/useParams";
import { useProjectParams } from "app/frontend/hooks/usePropsParams";
import { useCallback } from "react";

interface IArgs {
    newProjectParams?: Record<string, any>;
    forceNextHead?: number;
}

export const useOnContinue = (method: "get" | "post" = "get") => {
    const params = useParams();
    const projectType = useCurrentProjectType();
    const projectParams = useProjectParams();
    const head = useHead();
    const edit = useEdit();

    return useCallback(
        (args?: IArgs) => {
            const nextHead = () => {
                if (args?.forceNextHead) return args.forceNextHead;

                const next = edit ? head : head + 1;

                if (next < EEligibilityStep.PROJECT_TYPE) {
                    return EEligibilityStep.PROJECT_TYPE;
                } else if (next > EEligibilityStep.CONFIRMATION) {
                    return EEligibilityStep.CONFIRMATION;
                } else {
                    return next;
                }
            };

            router[method](
                ROUTES.Eligibility[projectType as Exclude<keyof typeof EProjectTypes, "ALL">],
                {
                    ...params,
                    head: nextHead(),
                    edit: 0,
                    project: {
                        ...projectParams,
                        ...args?.newProjectParams,
                    } as Record<string, any>,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                },
            );
        },
        [edit, head, method, params, projectParams, projectType],
    );
};
